import { Select, Tag } from "antd";
import axios from "axios";
import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { MoreHorizontal } from "react-feather";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import CustomizerContext from "../../_helper/Customizer";
import { useAPIUser } from "../../_helper/User/UserProvider";
import { OrganisationBranchApi } from "../../api";
import { fetchWishlist } from "../../api/wishlist.api";
import { LogEvents, LoggerContext } from "../../context/logging";
import actions from "../../redux/settings/actions";
import Leftbar from "./LeftBar";
import Rightbar from "./RightBar";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const organisationSelectionList = [
  "app/project/project-list",
  "app/vendor/vendor-list",
];
const Header = (props) => {
  const { Option } = Select;

  const logger = React.useContext(LoggerContext);
  const [sidebartoogle, setSidebartoogle] = useState(true);
  const [projects, setProjects] = useState([]);
  const [branches, setBranches] = useState([]);
  const { userDetails, setUserDetails } = useAPIUser();
  const { toggleIcon, toggleSidebarResponsive, setToggleIcon } =
    useContext(CustomizerContext);
  const [toggle, setToggle] = useState(true);
  const history = useNavigate();

  const getWishlist = async (projectId) => {
    fetchWishlist(projectId).then((wishlist) => {
      props.dispatch({
        type: actions.SET_WISHLIST_REQ,
        payload: {
          projectId,
          items:
            wishlist?.map((item) => ({
              project: projectId,
              product_id: item.productId.$oid,
              variant_id: item._id,
              variantDetails: item,
            })) ?? [],
        },
      });
    });
  };

  useEffect(() => {
    const {
      user,
      settings: { project, projectSelected, branch },
    } = props;
    console.log(project, "hi");
    if (project) {
      getWishlist(project.id);
    }
    fetchProjects({ branch: branch?.id });
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchProjects({ branch: props?.settings?.branch?.id });
  }, [props.settings.project]);

  useEffect(() => {
    fetchBranches();
    fetchProjects({ branch: props?.settings?.branch?.id });
  }, [userDetails]);

  const fetchProjects = (params = {}) => {
    // axios.get(`${ProjectApi}`, { params: { ...params } }).then((res) => {
    //   setProjects(res.data);
    // });
  };

  const fetchBranches = () => {
    const { dispatch } = props;
    axios.get(`${OrganisationBranchApi}`).then((res) => {
      console.log(userDetails, "user");
      setBranches(res.data);
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "all_branches",
          value: res?.data,
        },
      });
      if (!props?.settings?.branch?.id && res?.data[0]) {
        dispatch({
          type: "settings/CHANGE_SETTING",
          payload: {
            setting: "branch",
            value: res?.data[0],
          },
        });
      }
    });
  };
  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
          setToggleIcon(true);
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  // eslint-disable-next-line
  const [width] = useWindowSize();

  useEffect(() => {
    if (window.innerWidth <= 991) {
      setToggleIcon(true);
    } else {
      setToggleIcon(false);
    }
  }, []);
  useEffect(() => {}, [
    props?.settings?.all_branches,
    props?.settings?.organisation,
  ]);
  const handleProjectChange = (project) => {
    const { dispatch } = props;
    var projectDetails = projects?.filter((each) => each.id === project)[0];
    console.log("i-log> project details omg", projectDetails);
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: projectDetails,
      },
    });
    history(`/project-dashboard/` + projectDetails?.id);
  };
  const handleBranchChange = (branch) => {
    logger.log(LogEvents.selectBranch, {});
    const { dispatch } = props;
    fetchProjects({ branch: branch });
    var branchDetails = branches?.filter((each) => each.id === branch)[0];
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "branch",
        value: branchDetails,
      },
    });
    // history(`/project-dashboard`);
  };
  const clearProject = () => {
    const { dispatch } = props;
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: null,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: false,
      },
    });
    history(`app/project/project-list`);
  };
  const toggleResp = (value) => {
    setToggle(value);
    toggleSidebarResponsive(toggle);
  };
  const projectOption = projects?.map((each, ind) => (
    <Option key={ind} value={each.id}>
      {each.project_name}
    </Option>
  ));
  const branchOption = props?.settings?.all_branches?.map((each, ind) => (
    <Option key={ind} value={each.id}>
      <span className="text-capitalize">{each.branch_name}</span>
    </Option>
  ));
  console.log(props, projects, "props");
  return (
    <Fragment>
      <div className={`page-main-header ${toggleIcon ? "close_icon" : ""}`}>
        <Row className="main-header-right m-0">
          <Leftbar
            sidebartoogle={sidebartoogle}
            setSidebartoogle={setSidebartoogle}
          />
          {/* <Searchbar /> */}
          <Col
            style={{ paddingTop: 0, paddingBottom: 0 }}
            className="left-menu-header d-flex align-items-center"
          >
            {!props.settings.projectSelected && (
              <Select
                onChange={(e) => {
                  handleBranchChange(e);
                }}
                value={props?.settings?.branch?.id}
                style={{ width: "180px", marginRight: "10px" }}
                placeholder="Select Branch"
              >
                {branchOption}
              </Select>
            )}
            {props.settings.projectSelected ? (
              <div style={{ display: "flex" }}>
                <div>
                  <Tag
                    color="blue"
                    className="me-3 py-1 pe-3"
                    style={{ fontSize: "17px" }}
                  >
                    {props.settings?.project?.project_name} #
                    {props.settings?.project?.id}
                  </Tag>
                </div>
                {/* <Select
                  onChange={(e) => {
                    handleProjectChange(e);
                  }}
                  value={props.settings.project?.id}
                  // size="large"
                  style={{ width: "180px" }}
                  placeholder="Select Your Project"
                >
                  {projectOption}
                </Select> */}
                {props?.settings?.project?.project_code && (
                  <Tag className="mx-3 py-1 px-3" style={{ fontSize: "17px" }}>
                    {props.settings?.project?.project_code}
                  </Tag>
                )}
                <div>
                  <Tag className="mx-3 py-1 px-3" style={{ fontSize: "17px" }}>
                    {props.settings?.branch?.branch_name}
                  </Tag>
                </div>
              </div>
            ) : null}
            {/* {props.settings.projectSelected ? (
              <span
                className="mx-2"
                onClick={() => {
                  clearProject();
                }}
                style={{ cursor: "pointer" }}
              >
                <ShoppingBag />
              </span>
            ) : null} */}
          </Col>
          <Rightbar />
          <div
            className="d-lg-none mobile-toggle pull-right w-auto"
            onClick={() => toggleResp(!toggle)}
          >
            <MoreHorizontal />
          </div>
        </Row>
      </div>
    </Fragment>
  );
};

export default connect(mapStateToProps)(Header);
